import { literal, union } from 'io-ts/Decoder';

export const Id = union(
	literal('announcement'),
	literal('chat'),
	literal('job-assignment'),
	literal('transaction-assignment')
);
